import { createSlice } from '@reduxjs/toolkit';

import { CarsState } from '../../types';

import { CARS_STATE, CAR_NAVIGATION_HISTORY_PATH_TYPES } from '../../constants';

import { setEBoxLocations } from './setEBoxLocations';
import { resetEBoxLocations } from './resetEBoxLocations';
import { setVisibilityEBoxLocations } from './setVisibilityEBoxLocations';
import { updateEBoxLocationsFilter } from './updateEBoxLocationsFilter';

import { setSelectedEBoxLocation } from './setSelectedEBoxLocation';
import { resetSelectedCar } from './resetSelectedCar';

import { setADRClasses } from './setADRClasses';
import { setLocationSharingConstraints } from './setLocationSharingConstraints';
import { addLocationSharing } from './addLocationSharing';
import { setCarsLocationSharing } from './setCarsLocationSharing';
import { deleteCarLocationSharing } from './deleteCarLocationSharing';
import { setCarLocationHistorySharing } from './setCarLocationHistorySharing';
import { updateCarsLocationHistorySharingFilter } from './updateCarsLocationHistorySharingFilter';
import { setCarLocationHistorySharingSelectedLocation } from './setCarLocationHistorySharingSelectedLocation';
import { setSelectedLocationSharingAutoNumber } from './setSelectedLocationSharingAutoNumber';
import { resetLocationSharing } from './resetLocationSharing';

const initialState: CarsState = {
  eBoxLocations: {
    show: false,
    filter: {}
  },
  adrClasses: {},
  locationSharing: {},
  locationSharingConstraints: {},
  locationHistorySharing: {
    filter: {
      type: CAR_NAVIGATION_HISTORY_PATH_TYPES.all
    }
  }
}

export const carsSlice = createSlice({
  name: CARS_STATE,
  initialState,
  reducers: {
    resetEBoxLocations,

    setSelectedEBoxLocation,
    resetSelectedCar,
    updateEBoxLocationsFilter,

    setVisibilityEBoxLocations,

    updateCarsLocationHistorySharingFilter,
    setCarLocationHistorySharingSelectedLocation,
    setSelectedLocationSharingAutoNumber,
    resetLocationSharing
  },
  extraReducers: (builder) => {
    setEBoxLocations(builder);
    setADRClasses(builder);
    setLocationSharingConstraints(builder);
    addLocationSharing(builder);
    setCarsLocationSharing(builder);
    deleteCarLocationSharing(builder);
    setCarLocationHistorySharing(builder);
  }
});

export const carsActions = carsSlice.actions;
export const carsReducer = carsSlice.reducer;
